/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Head from 'next/head';
import Container from '../../atoms/Container';
import Styles from './TextBanner.css';
import { useAmp } from 'next/amp';

function TextBanner({
  text,
  src,
  usesDesktopImage,
  children,
  desktopSrc,
  enableDesktopTopMargin,
  enablePreload,
  altimg,
  imgPositionRight,
  imgPositionRightDesk,
}) {
  const isAmp = useAmp();

  return (
    <>
      {enablePreload && (
        <Head>
          {usesDesktopImage ? (
            <>
              <link rel="preload" href={src} as="image" media="(max-width: 991px)" />
              <link rel="preload" href={desktopSrc} as="image" media="(min-width: 992px)" />
            </>
          ) : (
            <link rel="preload" href={src} as="image" />
          )}
        </Head>
      )}
      <Container fullMobile>
        <div
          className={`banner-container ${enableDesktopTopMargin ? 'd-top-margin' : ''} ${
            isAmp ? '' : 'ampless'
          }`}
        >
          <img
            src={src}
            alt={altimg}
            layout="fill"
            className={`${usesDesktopImage ? 'img-mobile' : ''} ${imgPositionRight ? 'img-mobile-right' : ''}`}
          />

          {usesDesktopImage && (
            <img
              src={desktopSrc}
              alt={altimg}
              layout="fill"
              className={`img-desktop ${imgPositionRightDesk ? 'img-desk-right' : ''}`}
            />
          )}
          <h1
            className="baner-text-title"
            dangerouslySetInnerHTML={{
              __html: text || children,
            }}
          />
        </div>
      </Container>

      <style jsx>{Styles}</style>
    </>
  );
}

TextBanner.defaultProps = {
  text: undefined,
  src: '',
  fallbackSrc: '',
  usesDesktopImage: false,
  desktopSrc: '',
  fallbackDesktopSrc: '',
  enableDesktopTopMargin: false,
  enablePreload: false,
  imgPositionRight: false,
  imgPositionRightDesk: false,
};

export default TextBanner;
